import { usePanelNavContext } from "./PanelNavContext";

export interface IPanelAwareNavigate {
  /** True when rendered inside a panel (a `PanelNavProvider` is present). */
  inPanel: boolean;
  /**
   * The query string to append to a navigation target so the panel stays mounted.
   * `""` when not inside a panel — byte-identical to legacy navigation.
   */
  querySuffix: string;
}

/**
 * Foundational hook for navigating from inside a query-param-addressed
 * `BTSplitView` panel. Launchers append `querySuffix` to the path tail they build
 * (off `match.url`) and/or to the modal's `parentRoute`, so opening a child modal
 * does not drop the query that keeps the panel mounted.
 *
 * Outside a panel (no provider) `querySuffix` is `""` → no behavior change.
 */
export function usePanelAwareNavigate(): IPanelAwareNavigate {
  const panelSearch = usePanelNavContext();
  const inPanel = panelSearch !== undefined;
  return { inPanel, querySuffix: inPanel ? panelSearch : "" };
}
